import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';
import YourTeamCard from './YourTeamCard';

const styles = (theme) => ({
    root: {
        width: '100%',
    },
    noTeamSpan: {
        fontWeight: '500',
        fontSize: '14px',
    },
});

class YourTeamGrid extends React.Component {
    render() {
        const { yourteam, classes, style, t } = this.props;
        const items = [];
        // Customer Care Specialist is only used in Day One Details, so we filter it out here
        const filteredTeam = yourteam.filter(
            (member) => member.role !== 'Customer Care Specialist'
        );

        if (!filteredTeam || filteredTeam.length === 0) {
            items.push(
                <span className={classes.noTeamSpan}>Your team will be assigned soon.</span>
            );
        } else {
            for (let i = 0; i < filteredTeam.length; i++) {
                items.push(<YourTeamCard key={`teamCard-${i + 1}`} contact={filteredTeam[i]} />);
            }
        }

        return (
            <>
                <div classes={{ root: classes.header }}>{t('assignments:YOURTEAM.TITLE')}</div>
                <div className="YourTeamGridCards" style={style}>
                    {items}
                </div>
            </>
        );
    }
}

YourTeamGrid.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(YourTeamGrid));
